// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2dY6z","browseTitle":"styles_browseTitle__wTbf8","recentColumn":"styles_recentColumn__2oKHO"};